import { useRef, useState } from 'react'
import { searchTeam } from '../network/FootbalService';
import { useNavigate } from 'react-router-dom';
import logoImage from '../images/logo192.png'
import footballBall from '../images/icons8-soccer-ball-96.png'
import spainFlag from '../images/icons8-spain-96.png'
import gbFlag from '../images/icons8-uk-96.png'
import germanyFlag from '../images/icons8-germany-96.png'
import italyFlag from '../images/icons8-italy-96.png'
import { useAuth } from '../hooks/AuthContext';
import { analytics, auth } from '../services/Firebase';
import { Button, Modal, Spinner } from 'react-bootstrap';
import FeedbackPopup from '../utils/FeedbackPopup';
import { logEvent } from 'firebase/analytics';
import { useTranslation } from 'react-i18next';
import AppDownloadLinks from '../utils/AppDownloadLinks';
import { BarChart3, Calendar, ChartColumn, ChevronDown, Search, Football } from 'lucide-react';
import packageJson from '../../package.json';


export default function SearchPage() {
    const [inputValue, setInputValue] = useState('')
    const [teams, setTeams] = useState([])
    const [loading, setLoading] = useState(false)
    const [showLeagues, setShowLeagues] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const timeoutRef = useRef(null);
    const navigate = useNavigate()
    const { authUser, authLoading } = useAuth()
    const FEEDBACK_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSccjLKi7Z5IkROuz0YjRhtPa2elhfSH4PhZbTxVlaXPW7jinw/viewform'
    const { t } = useTranslation()
    const versionApp = packageJson.version;


    const LEAGUES = [
        { id: 2, name: "UEFA Champions League", flag: footballBall },
        { id: 3, name: "UEFA Europa League", flag: footballBall },
        { id: 39, name: "Premier League", type: "country", flag: gbFlag },
        { id: 140, name: "La Liga", type: "country", flag: spainFlag },
        { id: 78, name: "Bundesliga", type: "country", flag: germanyFlag },
        { id: 135, name: "Serie A", type: "country", flag: italyFlag }
    ];

    const handleInputChange = (e) => {
        const value = e.target.value
        setInputValue(value)

        clearTimeout(timeoutRef.current)

        if (value.length > 3) {
            setLoading(true)
            timeoutRef.current = setTimeout(async () => {
                console.log('Search for: ', value)
                try {
                    logEvent(analytics, 'search_triggered', {
                        keyword: value,
                        is_logged_in: !!authUser
                    })

                    const response = await searchTeam(value)
                    setTeams(response.data.response)
                    setLoading(false)
                    if (response.data.response.length < 1) {
                        logEvent(analytics, 'search_not_found', { keyword: value })
                    }
                    console.log(response.data.response)
                } catch (error) {
                    logEvent(analytics, 'search_error', { error_message: error.message })
                    setLoading(false)
                    console.log(error)
                }
            }, 500)
        } else {
            setTeams([])
        }
    }

    const onSelectTeam = (teamId, teamName) => {
        logEvent(analytics, 'search_selected', {
            club_name: teamName,
            is_logged_in: !!authUser
        })
        navigate(`/upcomingMatches/${teamId}`)
    }

    const goToLoginPage = () => {
        navigate('/login')
    }

    const handleFeedbackClick = () => {
        logEvent(analytics, 'feedback_bottom_click')
        window.open(FEEDBACK_URL, '_blank');
    }

    const handleProfileClick = () => {
        navigate('/profile')
    }

    return (
        <div className='search-page'>
            <div className="header-container">
                <div className='header-left'>
                    <img src={logoImage} alt="Logo" className="logo" />
                    <h3>Sigurica AI</h3>
                </div>
                <div className='header-right'>
                    {authLoading ? (
                        <div className="spinner-border spinner-border-sm-auth me-4" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    ) : authUser ? (
                        <Button onClick={() => handleProfileClick()} className='button-profile'><i className="bi bi-person-circle"></i>{t('memberProfile')}</Button>
                    ) : (
                        <Button onClick={() => goToLoginPage()} className='button-login'><i className="bi bi-box-arrow-in-right"></i>{t('loginMember')}</Button>
                    )}
                </div>
            </div>

            <div className="search-screen pt-0">
                <div className='beta-version-container-search'>
                    <h1 className='pb-0 pt-0 mb-0'>{t('searchPageSmartAssistent')}</h1>
                    <p className=''>{t('betaVersion')}</p>
                </div>
                <div className="overlay">
                    <div className="search-container mt-1">
                        <input
                            value={inputValue}
                            onChange={handleInputChange}
                            type='text' className={teams.length > 0 ? 'form-control searchInputWithTeamList' : 'form-control searchInput'}
                            placeholder={t('searchFootballTeam')}
                        />
                        {loading ? (
                            <div className="spinner-border searchLoadingSpinner" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        ) : (
                            <i className="bi bi-search searchIcon"></i>
                        )}
                        <ul className="dropdown-search">
                            {teams.map((item, index) => (
                                <li onClick={() => onSelectTeam(item.team.id, item.team.name)} key={index}>
                                    <span>{item.team.name}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="popular-leagues-container">
                        <button
                            className="btn-recommendations"
                            onClick={() => setShowLeagues(!showLeagues)}
                        >
                            <BarChart3 className='btn-recommendations-icon' />
                            {t('ourRecommendation')}
                            <ChevronDown
                                className={`chevron-icon ${showLeagues ? "rotate" : ""}`}
                            />
                        </button>

                        {showLeagues && (
                            <div className="popular-leagues-grid">
                                {LEAGUES.map((league) => (
                                    <Button
                                        key={league.id}
                                        className="league-button"
                                        onClick={() => {
                                            setSearchQuery(league.name);
                                            setShowLeagues(false);
                                            navigate(`/leagues/${league.id}`, { state: { leagueName: league.name, leagueFlag: league.flag } })
                                        }}
                                    >
                                        <img src={league.flag} alt={league.name} className="flag-icons w-5 h-5" />
                                        <span className="recommended-league-name">{league.name}</span>
                                    </Button>
                                ))}
                            </div>
                        )}
                    </div>
                    {/* <div className='button-recommendations-container'>
                        <button className='btn-recommendations'>
                            <BarChart3 className='btn-recommendations-icon' />
                            {t('ourRecommendation')}
                        </button>
                    </div> */}
                    <h4 className='tutorial-title'>{t('searchPageFunctionality')}</h4>

                    <div className='tutorial-grid'>
                        <div className="tutorial-card" >
                            <div className="step-icon-background">
                                <Search className="step-icon-color" />
                            </div>
                            <p className="step-title">{t('step1SearchTeam')}</p>
                            <div className="tutorial-info">
                                <p>{t('enterTeamName')}</p>
                            </div>
                        </div>

                        <div className="tutorial-card" >
                            <div className="step-icon-background">
                                <Calendar className="step-icon-color" />
                            </div>
                            <p className="step-title">{t('step2SelectMatch')}</p>
                            <div className="tutorial-info">
                                <p>{t('appShowsUpcomingMatches')}</p>
                            </div>
                        </div>

                        <div className="tutorial-card" >
                            <div className="step-icon-background">
                                <ChartColumn className="step-icon-color" />
                            </div>
                            <p className="step-title">{t('step3ViewAnalysis')}</p>
                            <div className="tutorial-info">
                                <p>{t('aiCollectsData')}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <FeedbackPopup />

                <footer className='footer-container'>
                    <AppDownloadLinks />
                    © 2025 Sigurica AI | v{versionApp} |
                    <a className='footer-item' href="/about" >{t('aboutApp')}</a> |
                    <a className='footer-item' href="/legal/privacy_policy.html" >{t('privacyPolicy')}</a> |
                    <a className='footer-item' href="/legal/terms.html" >{t('termsOfUse')}</a> |
                    <a className='footer-item' onClick={handleFeedbackClick}>{t('sendProposal')}</a>
                </footer>
            </div>
        </div>
    )
}
